import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export var initializeUserStream = createAction("".concat(actionKey, ".INIT"), function (streamId, deviationId, type) { return ({
    deviationId: deviationId,
    type: type,
    streamId: streamId,
}); });
//# sourceMappingURL=actions.js.map